import styled, { css } from 'styled-components';
import Image from 'next/image';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        display: inline-block;
        position: relative;

        svg {
            width: 100%;
            height: auto;
            color: var(--week-color, ${theme.colors.primary.hex});
        }
    `}
`;

export const Container = styled.div`
    width: 100%;
    height: auto;
`;

export const StyledRingD = styled(Image)`
    position: absolute;
    top: -2%;
    left: 17.5%;
    width: 10%;
    height: auto;
`;

export const StyledRingC = styled(Image)`
    position: absolute;
    top: -2%;
    left: 72.5%;
    width: 10%;
    height: auto;
`;
